<template>
    <section class="banner-section align-items-center">
        <!-- <div class="custom-container">
            <div class="row">
                <div class="col-md-10 col-lg-8">
                    <div class="banner-content">
                        <div class="navbar-brand logo banner-label" style="width:90% !important">
                            <img src="@/assets/img/banner-text.png" class="img-fluid" alt="Logo">
                        </div>
                        <div class="banner-btn">
                            <router-link to="/login" class="btn banner-primary">Ayo Bergabung Sekarang</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
  
        <div class="custom-container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-12 col-sm-12 col-lg">
                    
                        <VueSlickCarousel  v-bind="settings" v-if="lstkatbanner.length">
                            <div class="banner-content" v-for="(ref) in lstkatbanner" :key="ref.id">
                                <img  :src="ref.link_banner" />
                                <!-- <img  :src="loadImg(ref.link_banner)" /> -->
                            </div>
                        <!-- <VueSlickCarousel  v-bind="settings">
                            <div class="banner-content"><img src="@/assets/img/banner-2.jpg" /></div>
                            <div class="banner-content"><img src="@/assets/img/banner-2.jpg" /></div>
                            <div class="banner-content"><img src="@/assets/img/banner-2.jpg" /></div>
                          -->
                        </VueSlickCarousel>
                </div>
            </div>
        </div>

    </section> 
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

const images = require.context('@/assets/img/banners', false, /\.png$|\.jpg$/)

import axios from 'axios';
  export default {
    name: 'MyComponent',
    components: { VueSlickCarousel },
    data() {
      return {
        lstkat: [],
        lstkatbanner: [],
        settings: {
            // arrows: true,
            dots: true,
            // "infinite": true,
            // // "slidesToShow": 3,
            // "slidesToScroll": 1,
            "autoplay": true,
            // "speed": 2000,
            // "autoplaySpeed": 4000,
            // "cssEase": "linear"
            
            autoplaySpeed: 2500,
            dots: true,
            fade: true,
            // arrows: false,
            // "centerMode": true,
            // "centerPadding": "20px",
            "focusOnSelect": true,
            "infinite": true,
            "slidesToShow": 1,
            "speed": 500
        },
        settingCategory: {
            
            "infinite": true,
            "slidesToShow": 4,
            "speed": 500,
            "rows": 4,
            "slidesPerRow": 1
            
            // arrows: false,
            // "dots": false,
            // "infinite": false,
            // "speed": 500,
            // "slidesToShow": 6,
            // "slidesToScroll": 6,
            // "initialSlide": 0,
            // "responsive": [
            //     {
            //     "breakpoint": 1024,
            //     "settings": {
            //         "slidesToShow": 3,
            //         "slidesToScroll": 3,
            //         "infinite": true,
            //         "dots": true
            //     }
            //     },
            //     {
            //     "breakpoint": 600,
            //     "settings": {
            //         "slidesToShow": 3,
            //         "slidesToScroll": 3,
            //         "initialSlide": 2
            //     }
            //     },
            //     {
            //     "breakpoint": 480,
            //     "settings": {
            //         "slidesToShow": 4,
            //         // "rows": 2,
            //         // "slidesPerRow": 1
            //         "slidesToScroll": 1
            //     }
            //     }
            // ]
            }
      }
    },
    created:function(){
        // this.getAllKategori();
        this.getAllKategoriBanner();
    },
    methods: {
            getAllKategori: function () {
                axios.get('kategori')
                    .then(res => {
                        console.log(res);
                        this.lstkat = res.data.data;
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            },
        getAllKategoriBanner: function () {
            axios.get('kategoribanner/0')
                .then(res => {
                    // console.log(res);
                    this.lstkatbanner = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
	    loadImg(imgPath) {
            return images('./' + imgPath)        
        }
            
            // getDetail: function (ref) {
            //     if(localStorage.getItem('idUser'))
            //         this.$router.push({name:'siswa-paket-belajar-detail', params: {id: ref.id_paket}});
            //     else
            //         this.$router.push({name:'home-detail-paket', params: {id: ref.id_paket}});

            // },

    }
  }
// import { defineComponent } from 'vue';
// // import 'vue3-carousel/dist/carousel.css';
// import { Carousel, Navigation, Slide, Pagination } from 'vue3-carousel';
// export default defineComponent({
//   name: 'ExamplePagination',
//   components: {
//     Pagination,
//     Carousel,
//     Slide,
//     Navigation,
//   },
//   data: () => ({
//     // carousel settings
//     settings: {
//       itemsToShow: 1,
//       snapAlign: 'center',
//     },
//     // breakpoints are mobile first
//     // any settings not specified will fallback to the carousel settings
//     breakpoints: {
//       // 700px and up
//       700: {
//         itemsToShow: 3.5,
//         snapAlign: 'center',
//       },
//       // 1024 and up
//       1024: {
//         itemsToShow: 5,
//         snapAlign: 'start',
//       },
//     },
//   }),
// });

// import { Carousel, Slide } from 'vue-carousel';
// export default {
//   components: {
//     Carousel,
//     Slide
//   }
// };

//   import { ref } from "vue";
// import { MDBCarousel } from "mdb-vue-ui-kit";
//   export default {
//     components: {
//       MDBCarousel
//     },
//     setup() {
//       const items8 = [
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(19).webp",
//           alt: "...",
//           label: "First slide label",
//           caption: "Nulla vitae elit libero, a pharetra augue mollis interdum."
//         },
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(35).webp",
//           alt: "...",
//           label: "Second slide label",
//           caption: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
//         },
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(40).webp",
//           alt: "...",
//           label: "Third slide label",
//           caption:
//             "Praesent commodo cursus magna, vel scelerisque nisl consectetur."
//         }
//       ];
//       const carousel8 = ref(0);
//       return {
//         items8,
//         carousel8
//       };
//     }
//   };

</script>


// WEBPACK FOOTER //
// src/components/HomePage/Banner/index.vue